import { env } from '@edge/env'

export enum HandlerActions {
    CHANGE_TOTAL_PAGES = 'changeTotalPages',
    ERROR = 'error',
    LOADING_TRUE = 'loadingTrue',
    LOADING_FALSE = 'loadingFalse',
    REPORT_RENDERED = 'rendered',
}

export type VisualizeHelper = {
    login?: () => void
    runReport?: () => void
    renderNewPage?: () => void
    exportToPdf?: () => void
    handler?: Record<string, any>
}

interface Visualize {
    config: (args: VizConfig) => void
}

interface AuthParams {
    url?: string
    preAuth: boolean
    token?: string
    tokenName?: string
    loginFn?: (properties: any, request: any) => any
}

interface VizConfig {
    auth: AuthParams
}
export interface CustomWindow extends Window {
    visualize?: Visualize
}

export type VisualizeEventHandler = (input?: any, action?: HandlerActions) => void

const reportsVersion = env.REACT_APP_REPORTS_VERSION

const useVisualizeHelper = (handler?: any) => {
    const viz = (window as CustomWindow).visualize

    /**
     * Token-Based Authentication Login
     * @param userToken
     * @param jaspersoftServerUrl
     */
    const login = (userToken: string, auctionId: string, jaspersoftServerUrl: string) => {
        if (reportsVersion > 6) {
            viz?.config?.({
                auth: {
                    url: jaspersoftServerUrl,
                    preAuth: true,
                    token: `${userToken}&pipelineId=${auctionId}`,
                    tokenName: 'accessToken',
                },
            })
        } else {
            viz?.config?.({
                auth: {
                    preAuth: true,
                    loginFn: (properties: any, request: any) => {
                        return request({
                            url: jaspersoftServerUrl,
                            headers: {
                                'spark-auth': userToken,
                                'spark-refresh': userToken,
                                accessToken: `bearer ${userToken}`,
                                pipelineId: auctionId.toUpperCase(),
                                accept: 'application/json',
                            },
                        })
                    },
                },
            })
        }
    }

    return { login, handler }
}

export default useVisualizeHelper
